// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__Xwe7L","modal__content":"Modal_modal__content__DxW5g","modal__buttons":"Modal_modal__buttons__y2grp","modal__delete":"Modal_modal__delete__DLVOF"};